import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { UBXToast, UBXToastPosition } from '../models/toast/toast.model';
import { UBXColor } from '../models';

@Injectable({
    providedIn: 'root'
})
export class UBXToastService {
    private subject: Subject<UBXToast> = new Subject<UBXToast>();

    getToast(): Observable<UBXToast> {
        return this.subject.asObservable();
    }

    success(position: UBXToastPosition, message: string, timer?: number | boolean) {
        this.pushToast(UBXColor.Scs, position, 'Success', message, timer);
    }
    error(position: UBXToastPosition, message: string, timer?: number | boolean) {
        this.pushToast(UBXColor.Dgr, position, 'Error', message, timer);
    }
    warning(position: UBXToastPosition, message: string, timer?: number | boolean) {
        this.pushToast(UBXColor.Wrn, position, 'Warning', message, timer);
    }
    info(position: UBXToastPosition, message: string, timer?: number | boolean) {
        this.pushToast(UBXColor.Inf, position, 'Infomation', message, timer);
    }

    private pushToast(type: UBXColor, position: UBXToastPosition, label: string, message: string, timer: number | boolean = 5000) {
        this.subject.next({ type, position, label, message, timer } as UBXToast);
    }
}
